import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ICommonListPayloadDto,
  IDashboardRes,
  IDashboardResponse,
} from "../type/type.ts";
import Axios from "../axios-config/axiosInstance.ts";

interface DashboardState {
  dashboardStats: IDashboardRes[];
  loading: boolean;
  error: string | null;
  offset: number;
  limit: number;
  sortField: string;
  sortOrder: number;
  dataCount: number;
  searchInput: string;
}

const initialState: DashboardState = {
  dashboardStats: [],
  loading: false,
  error: null,
  dataCount: 0,
  offset: 0,
  limit: 10,
  sortField: "createdOn",
  sortOrder: 1,
  searchInput: ""
};

export const fetchDashboardStats = createAsyncThunk<IDashboardResponse, ICommonListPayloadDto>(
  'dashboard/stats',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.get<IDashboardResponse>(`dashboard/stats`, { params: payload });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch services");
    }
  }
);



// Create Slice
const DashboardSlice = createSlice({
  name: "DashboardState",
  initialState,
  reducers: {
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSortField: (state, action) => {
      state.sortField = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    setSearchInput: (state, action) => {
      state.searchInput = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action: PayloadAction<IDashboardResponse>) => {
        state.loading = false;
        state.dashboardStats = [action.payload.data]; 
        state.dataCount = 1;
      })      

      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to load services";
      });
  },
});

export const { setOffset, setLimit, setSortField, setSortOrder, setSearchInput } = DashboardSlice.actions;
export default DashboardSlice.reducer;
